import type { ReduxActionOutcome, ReduxNonApiAction } from 'app/store/storeTypes';
import { CLEAR_ERROR } from './types';

export const doClearError = () => ({ type: CLEAR_ERROR }) as const satisfies ReduxNonApiAction;

export type ErrorActionOutcomes = ReduxActionOutcome<ReturnType<typeof doClearError>>;
